import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import logoEspresso from '../assets/logo-espresso.webp'
import heartEspresso from '../assets/heart-espresso.webp'

export default function Footer() {
  const { t } = useTranslation()

  return (
    <footer className="bg-sand border-t border-espresso/10 py-10 px-6">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 items-start">
        {/* Left */}
        <div>
          <img src={logoEspresso} alt="buenas studio" className="h-14 mb-3" />
          <p className="font-body text-espresso/80 text-xs">
            {t('footer.subtitle')}
            <br />
            {t('footer.locations')}
          </p>
        </div>

        {/* Center */}
        <div className="flex flex-col items-start md:items-center gap-2 text-left md:text-center">
          <p className="font-headline text-espresso/70 text-base">
            {t('footer.tagline')}{' '}
            <img src={heartEspresso} alt="buenas heart" className="w-4 inline ml-2" />
          </p>
        </div>

        {/* Right */}
        <div className="text-left sm:text-right md:text-right">
          <div className="flex flex-col items-start md:items-end gap-1.5 mb-3">
            <a
              href="https://www.instagram.com/buenas.studio"
              target="_blank"
              rel="noopener noreferrer"
              className="min-h-[24px] py-1 inline-flex flex-row-reverse md:flex-row items-center gap-1.5 text-espresso/80 hover:text-rot transition-colors"
              aria-label="@buenas.studio on Instagram"
            >
              <span className="font-body text-xs">@buenas.studio</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="w-4 h-4"
              >
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                <circle cx="12" cy="12" r="5" />
                <circle cx="17.5" cy="6.5" r="1.5" fill="currentColor" stroke="none" />
              </svg>
            </a>
            <a
              href="https://www.linkedin.com/company/buenas-studio/"
              target="_blank"
              rel="noopener noreferrer"
              className="min-h-[24px] py-1 inline-flex flex-row-reverse md:flex-row items-center gap-1.5 text-espresso/80 hover:text-rot transition-colors"
              aria-label="buenas-studio on LinkedIn"
            >
              <span className="font-body text-xs">buenas-studio</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="w-4 h-4"
              >
                <rect x="2" y="2" width="20" height="20" rx="4" ry="4" />
                <line x1="8" y1="11" x2="8" y2="16" />
                <line x1="8" y1="8" x2="8" y2="8.01" />
                <path d="M12 16v-5M16 16v-3a2 2 0 0 0-4 0" />
              </svg>
            </a>
          </div>
          <p className="font-body text-espresso/80 text-xs leading-loose">
            {t('footer.copyright')}
            <br />
            <Link to="/legal" className="hover:text-rot transition-colors">
              {t('footer.link1')}
            </Link>
            {' · '}
            <Link to="/privacy" className="hover:text-rot transition-colors">
              {t('footer.link2')}
            </Link>
          </p>
        </div>
      </div>
    </footer>
  )
}
